import * as React from 'react';

import * as styles from './styles.css';

interface IModalContent {
  videoSrc: string;
}
export const VideoPlaybackModalContent: React.FC<IModalContent> = ({ videoSrc }) => {
  return (
    <div className={styles['modal-content']} data-testid="video-playback-modal-content">
      <iframe
        className={styles['video-iframe']}
        src={videoSrc}
        title="Видео о возможностях Циан.Сделки"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};
